import Vue from 'vue';

export const getMaskedEmail = (email) => {
    try {
        if (!email) return '';
        const parts = email.split(/@(.+)/);
        return !parts[1]
            ? parts[0]
            : `${parts[0].substr(0, parts[0].length / 2)}${'*'.repeat(
                  parts[0].length / 2 + (parts[0].length % 2 === 0 ? 0 : 0.5)
              )}@${parts[1]}`;
    } catch {
        return email;
    }
};

export const getMaskedPhone = (number) => {
    try {
        if (!number) return '';
        if (number.length <= 2) return '**';
        return `${'*'.repeat(number.length - 2)}${number.substr(number.length - 2)}`;
    } catch {
        return number;
    }
};

export const waitForCookieSet = (key, timeout = 5000) => {
    return new Promise(async (resolve, reject) => {
        const ts = Date.now();
        let cookie = Vue.cookie.get(key);
        for (; !cookie && Date.now() - ts < timeout; cookie = Vue.cookie.get(key)) {
            await new Promise((r) => setTimeout(r, 100));
        }
        if (cookie) resolve(cookie);
        else reject();
    });
};

export default { getMaskedEmail, getMaskedPhone };
